import React from 'react';
import Card from '../common/Card';
import { theme } from '../../config/theme';

const StatsCard = ({ title, value, icon, trend, trendValue, onClick }) => {
  const valueStyles = {
    fontSize: theme.typography.fontSize['3xl'],
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.text.primary,
    marginTop: theme.spacing.sm,
    marginBottom: theme.spacing.xs,
  };

  const trendStyles = {
    fontSize: theme.typography.fontSize.sm,
    color: trend === 'up' ? theme.colors.success : trend === 'down' ? theme.colors.error : theme.colors.text.secondary,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.xs,
  };

  const iconContainerStyles = {
    opacity: 0.5,
    color: theme.colors.primary.main,
  };

  return (
    <Card hoverable={!!onClick} onClick={onClick} padding="lg">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <div>
          <div style={{ fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary, marginBottom: theme.spacing.xs }}>
            {title}
          </div>
          <div style={valueStyles}>{value}</div>
          {trend && (
            <div style={trendStyles}>
              <span>{trend === 'up' ? '↑' : '↓'}</span>
              <span>{trendValue}</span>
            </div>
          )}
        </div>
        {icon && (
          <div style={iconContainerStyles}>
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
};

export default StatsCard;